<template>
    <p style="width:100%" :style="{ textAlign: btn.textAlign }">
        <span :class="btn.css" :style="{ fontSize: btn.fontSize+'px', lineHeight: btn.lineHeight, textAlign: btn.textAlign, backgroundColor: btn.backgroundColor, color: btn.fontColor }" style="width: 100%;" v-html="btn.value"></span>
    </p>
</template>

<script>

export default {
    name: 'c-text',
    props: ['btn','page']
}    
</script>